// @ts-expect-error
export const isAppEnvironmentAndroid: boolean = window.ReactObserver;
